module.exports = __webpack_public_path__ + "img/pricing_hero.ed96d556.webp";